/*
* @描述: 订单售后详情
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-02-18 10:12:10
*/
<template>
    <el-dialog :before-close="handleDialogClose"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :title="type_name"
               :visible.sync="dialogVisible"
               class="custom_form_dialog"
               custom-class="after_sale_detail_dialog"
               width="800px">
        <div class="after_sale_detail_content">
            <afterSaleApproveDetail :after_sales_type="type" :form_detail="after_sale_detail"/>
        </div>
    </el-dialog>
</template>
<script>
    import afterSaleApproveDetail from "@/components/pComponents/afterSaleApproveDetail";

    export default {
        name: "OrderAfterSaleDetail",
        data() {
            return {}
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                default: '',
            },
            type_name: {
                type: String,
                default: '',
            },
            after_sale_detail: {
                type: [Object,Array],
                default: () => {
                    return {};
                },
            },
        },
        components: {
            afterSaleApproveDetail
        },
        created() {

        },
        mounted() {
        },
        methods: {
            // 关闭弹窗
            handleDialogClose() {
                this.$emit('update:dialogVisible', false)
            },
        },
    }
</script>
<style lang="scss">
    .after_sale_detail_dialog {
        height: 780px;

        .el-dialog__body {
            padding: 24px;
        }
    }

</style>